{
    "ChanneltypesLabel": "Type(s) de canal :",
    "ChanneltypesOptionAny": "[N'importe quelle chaîne]",
    "ChanneltypesOptionVoice": "Appels vocaux",
    "ChanneltypesOptionChat": "Chats",
    "ChanneltypesOptionEmail": "Emails",
    "CalltypedirectionLabel": "Type d'appel \/ Direction :",
    "CalltypedirectionOptionAny": "[Tout type d'appel]",
    "CalltypedirectionOptionUnknownorinitiating": "[Inconnu ou initié]",
    "CalltypedirectionOptionInbound": "Inbound uniquement",
    "CalltypedirectionOptionOutbound": "Outbound uniquement",
    "CalltypedirectionOptionExternalAll": "Externe uniquement",
    "CalltypedirectionOptionExternalInbound": "Externe (entrant seulement)",
    "CalltypedirectionOptionExternalOutbound": "Externe (sortant uniquement)",
    "CalltypedirectionOptionExternalTrktotrk": "External Trunk-To-Trunk",
    "CalltypedirectionOptionInternalAll": "Interne seulement",
    "CalltypedirectionOptionInternalInbound": "Interne (entrant seulement)",
    "CalltypedirectionOptionInternalOutbound": "Interne (sortant uniquement)",
    "AnswertypeLabel": "Type de réponse :",
    "ClicalleridreceivedAny": "[N'importe lequel]",
    "ClicalleridreceivedNone": "Sans CLI\/CallerID",
    "ClicalleridreceivedReceived": "Avec CLI\/CallerID",
    "AnswertypeOptionAny": "[Tout type de réponse]",
    "AnswertypeOptionNotans": "Pas de réponse",
    "AnswertypeOptionAns": "Réponse :",
    "AnswertypeOptionAbandoned": "Abandonné",
    "AnswertypeOptionAdvancedFrom": "Avancé De",
    "AnswertypeOptionAdvancedTo": "Avancé à",
    "AnswertypeOptionOverflowedFrom": "Débordé Off",
    "AnswertypeOptionOverflowedTo": "Débordé dans",
    "ClicalleridreceivedLabel": "CLI \/ CallerID reçu :",
    "DiddigitsLabel": "Chiffres DDI :",
    "AccountcodesLabel": "Code(s) de compte :",
    "CallidentifierLabel": "Identificateur d'appel (plate-forme téléphonique) :",
    "SubjectfilterLabel": "Filtre à sujets :",
    "TreatconfcallasExternalLabel": "Traiter la conférence téléphonique comme un appel externe :",
    "MiscellaneousFiltering_SectionHeader": "Filtrage divers",
    "MiscellaneousFiltering_AnyPlaceholder": "[N'importe lequel]",
    "NAME": "MiscellaneousFiltering"
}